export const sf3CoreApiUri = process.env.REACT_APP_SF3_CORE_API_URL || 'http://localhost:8080/';
export const sf3DesktopUri = process.env.REACT_APP_SF3_DESKTOP_URL || 'https://localhost:5000';
